<script setup>
import { useMainStore } from "@/stores/main";

const mainStore = useMainStore();

window.mainStore = mainStore;
</script>

<template>
  <router-view />
</template>